import { memo, useCallback } from "react";
import useSearchInvoiceService from "../../../../../helper/services/searchInvoiceServices"
import { SearchSingleFunction } from "../../../../../model/searchInvoiceModels";
import SearchSingleForm from "../../../../UI/Search/Single/SearchSingleForm"

const Proof: React.FC = () => {
    const searchInvoiceService = useSearchInvoiceService();

    const searchSingleInvoiceFunction: SearchSingleFunction = useCallback((taxCode, securityCode) => {
        return searchInvoiceService.getProofOfPersonalIncomeTaxReduce(taxCode, securityCode);
    }, [])
    return <SearchSingleForm
        header="chứng từ TNCN"
        searchInvoice={searchSingleInvoiceFunction}
    />
}
export default memo(Proof);